import { render, staticRenderFns } from "./checkRecord.vue?vue&type=template&id=8c8f9a1a&scoped=true&"
import script from "./checkRecord.vue?vue&type=script&lang=js&"
export * from "./checkRecord.vue?vue&type=script&lang=js&"
import style0 from "./checkRecord.vue?vue&type=style&index=0&id=8c8f9a1a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c8f9a1a",
  null
  
)

export default component.exports